var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "router-link",
    {
      staticClass: "ref-link",
      attrs: {
        to: { name: _vm.pageName, params: _vm.pageParams },
        target: "_blank",
      },
    },
    [_vm._v("\n    " + _vm._s(_vm.linkText) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }